<template>
  <div style="height: 0; width: 0;">
    <newsletter-registration-dialog/>
    <corona-dialog/>
    <template v-if="!$auth.check()">
      <user-login-dialog/>
      <user-registration-required-dialog/>
      <user-registration-dialog/>
      <user-password-reset-dialog/>
    </template>
    <template v-if="authUser">
      <pdf-dialog/>
      <contact-form-dialog/>
    </template>
    <template v-if="authUser && !authUser.is_employee">
      <only-for-employees-dialog/>
      <decline-employee-dialog/>
      <edit-application-dialog/>
      <edit-employee-dialog/>
      <edit-employee-re-enter-dialog/>
    </template>
    <template v-if="authUser && authUser.is_employee">
      <report-problem-dialog/>
    </template>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';

// Not logged in import
import UserRegistrationRequiredDialog from '../user/UserRegistrationRequiredDialog.vue';
import UserRegistrationDialog from '../user/UserRegistrationDialog.vue';
import UserLoginDialog from '../user/UserLoginDialog.vue';
import UserPasswordResetDialog from '../user/UserPasswordResetDialog.vue';
import NewsletterRegistrationDialog from '../NewsletterRegistrationDialog.vue';
import CoronaDialog from './CoronaDialog.vue';

// Logged in import
import PdfDialog from '../PdfDialog.vue';
import ContactFormDialog from '../ContactFormDialog.vue';

// Company import
import OnlyForEmployeesDialog from '../company/OnlyForEmployeesDialog.vue';
import DeclineEmployeeDialog from '../company/employees/DeclineEmployeeDialog.vue';
import EditApplicationDialog from '../company/applications/EditApplicationDialog.vue';
import EditEmployeeReEnterDialog from '../company/employees/EditEmployeeReEnterDialog.vue';
import EditEmployeeDialog from '../company/employees/EditEmployeeDialog.vue';

// Employee import
import ReportProblemDialog from '../employee/ReportProblemDialog.vue';

const { mapState: mapUserState } = createNamespacedHelpers('user');

export default {
  name: 'Dialogs',
  components: {
    UserRegistrationRequiredDialog,
    UserRegistrationDialog,
    UserLoginDialog,
    UserPasswordResetDialog,
    NewsletterRegistrationDialog,
    CoronaDialog,
    PdfDialog,
    ContactFormDialog,
    OnlyForEmployeesDialog,
    DeclineEmployeeDialog,
    EditEmployeeReEnterDialog,
    EditEmployeeDialog,
    EditApplicationDialog,
    ReportProblemDialog,
  },
  computed: {
    ...mapUserState([
      'authUser',
    ]),
  },
};
</script>
